import { RouteConfig } from 'vue-router';
import { PermissionTypeEnum } from '../Api';
import IssuesSolvingList from './pages/IssuesSolvingList.vue';
import ReportIssue from './pages/ReportIssue.vue';

export default [
    {
        path: '/:tenantId/issues-solving',
        name: 'IssuesSolving',
        component: IssuesSolvingList,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.ReportIssueSolving, PermissionTypeEnum.PerformAudit],
            checkLicence: true,
            title: 'menu.issuesSolving',
        },
    },
    {
        path: '/:tenantId/issues-reporting/:auditId',
        name: 'IssueReporting',
        component: ReportIssue,
        props: (route) => ({ tenantId: route.params.tenantId, auditId: route.params.auditId }),
        meta: {
            permissions: [
                PermissionTypeEnum.ReportIssueSolving,
                PermissionTypeEnum.PerformAudit,
                PermissionTypeEnum.ShiftWork,
                PermissionTypeEnum.ShiftWorkLimited,
                PermissionTypeEnum.ShiftManagement,
            ],
            checkLicence: true,
            title: 'menu.issuesSolving',
        },
    },
] as RouteConfig[];
